import { render, staticRenderFns } from "./regist.vue?vue&type=template&id=e72a4e34&scoped=true"
import script from "./regist.vue?vue&type=script&lang=js"
export * from "./regist.vue?vue&type=script&lang=js"
import style0 from "./regist.vue?vue&type=style&index=0&id=e72a4e34&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e72a4e34",
  null
  
)

export default component.exports